import { ApolloLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { metrics } from '@seek/metrics-js';

import { hasGraphQLErrorCode } from 'src/modules/graphql-client/errors';
import { navigateToUrl } from 'src/utils';

import { GraphQLErrorCode } from '../types';

import { isMutation } from './is-mutation';

const handleUnauthedErrors = (error: unknown): void => {
  if (!hasGraphQLErrorCode(error, GraphQLErrorCode.unauthenticated)) {
    return;
  }

  const jobId = typeof window !== 'undefined' ? window.CONFIG.JOB_ID : null;
  navigateToUrl(`/oauth/login?returnUrl=/job/${jobId}/apply`);
};

export const onErrorLink = new ErrorLink(({ error, operation }) => {
  if (isMutation({ operation })) {
    handleUnauthedErrors(error);
  }

  metrics.count(`apply-graphql-error-${operation.operationName}`);
});

export const mutationMetricsLink = new ApolloLink((operation, forward) => {
  if (isMutation({ operation })) {
    metrics.count(`apply-graphql-mutation-${operation.operationName}`);
  }
  return forward(operation);
});
